import React, {useEffect, useRef, useState} from 'react';
import {
    addCompanyCategory,
    addCompanyInitialMessage,
    addSkill,
    deleteCompanyCategory,
    deleteCompanyInitialMessage,
    deleteSkill,
    editCompanyCategory,
    editCompanyInitialMessage,
    getCompanyCategories,
    getCompanyInitialMessage,
    getSkills,
    getWebhooks,
    updateSkill
} from '../../../../../../../services/company/api';
import config from "../../../../../../../config";
import Webhooks from "./webhooks/Webhooks";
import ForbiddenWordsConfig from "./forbiddenWords/ForbiddenWordsConfig";
import Templates from "./templates";
import Skills from "./skills/Skills";
import Categories from "./categories/Categories";
import InitialMessages from "./initialMessages/InitialMessages";
import Translate from "../../../../../../../components/Translate";
import './Resources.css'
import Tabs from "../../../../../../../components-new/ui/Tabs";

function Resources({tariff, client, user, clients, addNotification}) {
    const [categories, setCategories] = useState([]);
    const [newCategory, setNewCategory] = useState('');
    const [visibleCategories, setVisibleCategories] = useState({});

    const [skills, setSkills] = useState([]);
    const [newSkill, setNewSkill] = useState('');
    const [webhooks, setWebhooks] = useState([]);
    const [updateWebhooksState, setUpdateWebhooksState] = useState(false);
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const [editIndex, setEditIndex] = useState(-1);
    const [editId, setEditId] = useState(-1);
    const [visibleMessages, setVisibleMessages] = useState({});
    const {features} = tariff
    const [activeTab, setActiveTab] = useState('initialMessages');
    const inputRef = useRef(null);

    useEffect(() => {
        getCompanyInitialMessage(client.id).then((data) => {
            setMessages(data);
            data.map(d => {
                if (d.enabled) {
                    visibleMessages[d.id] = d;
                }
            });
        });
        getCompanyCategories(client.id).then((data) => {
            setCategories(data);
            const initialVisibleState = {};
            data.forEach(category => {
                initialVisibleState[category.name] = category.enabled;
            });
            setVisibleCategories(initialVisibleState);
        });


        getSkills(client.id).then((data) => {
            setSkills(data);
        });

        getWebhooks(client.id).then(setWebhooks);

    }, [client.id]);

    useEffect(() => {
        getWebhooks(client.id).then(setWebhooks);
    }, [updateWebhooksState]);

    const handleInputChange = (event) => setNewCategory(event.target.value);

    const handleAddCategory = () => {
        if (newCategory.trim()) {
            addCompanyCategory(client.id, newCategory)
                .then(data => {
                    setCategories([...categories, {name: newCategory}]);
                    setVisibleCategories({...visibleCategories, [newCategory]: true});
                    setNewCategory('');
                    addNotification("added", config.notificationLevels.success)
                })
                .catch(() => {
                    addNotification("somethingWentWrong", config.notificationLevels.error)
                });
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') handleAddCategory();
    };

    const handleDeleteCategory = (index, categoryName) => {
        const updatedCategories = [...categories];
        updatedCategories.splice(index, 1);
        setCategories(updatedCategories);
        const {[categoryName]: _, ...updatedVisibleCategories} = visibleCategories;
        setVisibleCategories(updatedVisibleCategories);
        deleteCompanyCategory(client.id, categoryName)
            .then(() => {
                addNotification("deleted", config.notificationLevels.info)
            })
            .catch(() => {
                addNotification("somethingWentWrong", config.notificationLevels.error)
            });
    };

    const toggleCategoryVisibility = (name, id) => {
        setVisibleCategories(prevVisibleCategories => ({
            ...prevVisibleCategories,
            [name]: !prevVisibleCategories[name]
        }));
        editCompanyCategory(client.id, id, !visibleCategories[name])
            .then(() => {
                addNotification("updated", config.notificationLevels.info)
            })
            .catch(() => {
                addNotification("somethingWentWrong", config.notificationLevels.error)
            });
    };


    const handleSkillInputChange = (event) => setNewSkill(event.target.value);

    const handleAddSkill = () => {
        if (newSkill.trim()) {
            addSkill(client.id, newSkill)
                .then((data) => {
                    setSkills([...skills, {id: data.id, name: newSkill}]);
                    setNewSkill('');
                    addNotification("added", config.notificationLevels.success)
                })
                .catch(() => {
                    addNotification("somethingWentWrong", config.notificationLevels.error)
                });
        }
    };

    const handleDeleteSkill = (skillId) => {
        deleteSkill(client.id, skillId)
            .then(() => {
                setSkills(skills.filter(skill => skill.id !== skillId));
                addNotification("deleted", config.notificationLevels.info)
            })
            .catch(() => {
                addNotification("somethingWentWrong", config.notificationLevels.error)
            });
    };

    const handleUpdateSkill = (skillId, updatedName) => {
        updateSkill(client.id, skillId, updatedName)
            .then(() => {
                setSkills(skills.map(skill =>
                    skill.id === skillId ? {...skill, name: updatedName} : skill
                ));
                addNotification("updated", config.notificationLevels.info)
            })
            .catch(() => {
                addNotification("somethingWentWrong", config.notificationLevels.error)
            });
    };

    const handleSkillOnChange = (skillId, updatedName) => {
        setSkills(skills.map(skill =>
            skill.id === skillId ? {...skill, name: updatedName} : skill
        ));
    };

    const handleInitialMessageKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleAddOrSaveMessage();
        }
    };

    const handleEditMessage = (index, id) => {
        setNewMessage(messages[index].text);
        setEditIndex(index);
        setEditId(id);
    };

    /* leaves the message as it was and empties the box above it */
    const handleCancelEdit = () => {
        setNewMessage('');
        setEditIndex(-1);
        setEditId(-1);
    };

    const handleDeleteMessage = (index, id) => {
        const messageToDelete = messages[index];
        const updatedMessages = messages.filter((_, idx) => idx !== index);
        setMessages(updatedMessages);

        const {[messageToDelete.id]: _, ...updatedVisibleMessages} = visibleMessages;
        setVisibleMessages(updatedVisibleMessages);

        deleteCompanyInitialMessage(id, client.id)
            .then(() => {
                addNotification("deleted", config.notificationLevels.info)
            })
            .catch(() => {
                addNotification("somethingWentWrong", config.notificationLevels.error)
            });
    };

    const toggleMessageVisibility = (message, bool) => {
        setMessages(prevMessages =>
            prevMessages.map(msg =>
                msg.id === message.id ? {...msg, enabled: bool} : msg
            )
        );
        const id = message.id;
        setVisibleMessages(prevVisibleMessages => ({
            ...prevVisibleMessages,
            [id]: !prevVisibleMessages[id]
        }));
        const initialMessage = {
            id: id,
            companyId: client.id,
            text: message.text,
            enabled: !message.enabled
        };
        editCompanyInitialMessage(initialMessage, client.id)
            .then(() => {
                addNotification("updated", config.notificationLevels.info)
            })
            .catch(() => {
                addNotification("somethingWentWrong", config.notificationLevels.error)
            });
    };

    const handleInitialMessageInputChange = (event) => {
        setNewMessage(event.target.value);
    };

    const handleAddOrSaveMessage = () => {
        if (newMessage.trim() !== '') {
            if (editIndex >= 0) {
                const updatedMessages = [...messages];
                updatedMessages[editIndex].text = newMessage;
                setMessages(updatedMessages);
                setEditIndex(-1);

                const initialMessage = {
                    id: editId,
                    companyId: client.id,
                    text: newMessage,
                    enabled: true
                };
                visibleMessages[editId] = initialMessage;
                editCompanyInitialMessage(initialMessage, client.id)
                    .then(() => {
                        addNotification("updated", config.notificationLevels.info)
                    })
                    .catch(() => {
                        addNotification("somethingWentWrong", config.notificationLevels.error)
                    });
            } else {
                const initialMessage = {
                    companyId: client.id,
                    text: newMessage,
                    enabled: true
                };
                addCompanyInitialMessage(initialMessage, client.id)
                    .then((data) => {
                        const newMessageObject = {id: data.id, text: newMessage, enabled: true};
                        const newMessages = [...messages, newMessageObject];
                        setMessages(newMessages);
                        setVisibleMessages({...visibleMessages, [newMessageObject.id]: true});
                        addNotification("added", config.notificationLevels.success)
                    })
                    .catch(() => {
                        addNotification("somethingWentWrong", config.notificationLevels.error)
                    });
            }
            setNewMessage('');
        }
    };

    return (
        <div className="resources">

            <Tabs
                selectedTab={activeTab}
                onTabChange={setActiveTab}
                tabs={[
                    ...(features.includes(config.features.INITIAL_MESSAGES)
                        ? [{label: 'initialMessages', value: 'initialMessages'}]
                        : []),
                    ...(features.includes(config.features.TEMPLATES)
                        ? [{label: 'templates', value: 'templates'}]
                        : []),
                    ...(features.includes(config.features.CATEGORIES)
                        ? [{label: 'categories', value: 'categories'}]
                        : []),
                    ...(features.includes(config.features.SKILLS)
                        ? [{label: 'skills', value: 'skills'}]
                        : []),
                    ...(features.includes(config.features.FORBIDDEN_WORDS)
                        ? [{label: 'forbiddenWords', value: 'forbiddenWords'}]
                        : []),
                    ...(features.includes(config.features.WEBHOOKS)
                        ? [{label: 'webhooks', value: 'webhooks'}]
                        : []),
                ]}
                renderTab={tab => <Translate text={tab.label}/>}
            />

            {features.includes(config.features.INITIAL_MESSAGES) && activeTab === 'initialMessages' &&
                <InitialMessages
                    newMessage={newMessage}
                    user={user}
                    messages={messages}
                    handleEditMessage={handleEditMessage}
                    handleCancelEdit={handleCancelEdit}
                    toggleMessageVisibility={toggleMessageVisibility}
                    editIndex={editIndex}
                    handleAddOrSaveMessage={handleAddOrSaveMessage}
                    handleDeleteMessage={handleDeleteMessage}
                    handleInitialMessageKeyPress={handleInitialMessageKeyPress}
                    handleInitialMessageInputChange={handleInitialMessageInputChange}
                />
            }

            {features.includes(config.features.TEMPLATES) && activeTab === 'templates' &&
                <Templates
                    user={user}
                    clients={clients}
                    client={client}
                    addNotification={addNotification}
                />
            }

            {features.includes(config.features.CATEGORIES) && activeTab === 'categories' &&
                <Categories
                    categories={categories}
                    newCategory={newCategory}
                    toggleCategoryVisibility={toggleCategoryVisibility}
                    visibleCategories={visibleCategories}
                    handleAddCategory={handleAddCategory}
                    handleDeleteCategory={handleDeleteCategory}
                    handleInputChange={handleInputChange}
                    handleKeyPress={handleKeyPress}
                />
            }

            {features.includes(config.features.SKILLS) && activeTab === 'skills' &&
                <Skills
                    skills={skills}
                    handleUpdateSkill={handleUpdateSkill}
                    handleSkillOnChange={handleSkillOnChange}
                    newSkill={newSkill}
                    handleAddSkill={handleAddSkill}
                    handleDeleteSkill={handleDeleteSkill}
                    handleSkillInputChange={handleSkillInputChange}
                />
            }

            {features.includes(config.features.WEBHOOKS) && activeTab === 'webhooks' &&
                <Webhooks
                    updateWebhooksState={updateWebhooksState}
                    addNotification={addNotification}
                    setUpdateWebhooksState={setUpdateWebhooksState}
                    client={client}
                    webhooks={webhooks}
                    user={user}
                />
            }

            {features.includes(config.features.FORBIDDEN_WORDS) && activeTab === 'forbiddenWords' &&
                <ForbiddenWordsConfig client={client}/>
            }

        </div>
    );
}

export default Resources;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/resources/Resources.jsx